import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import _str from 'underscore.string';
import { SIMPLE_VALUE_PROP } from 'ui/consts/prop-types';
import Popover from 'ui/components/popover';
import { validateField } from 'ui/utils/input-helper';
import { wireValue } from 'ui/hoc/prop-wire';

var log = require('loglevel').getLogger('core/components/textarea');
/**
 * A React Textarea. Note this is wrapper around react builtin textarea element, major differences are:
 *
 * * Provides validation tooltip (optional)
 * * Only fire onChange event when the field has lost focus
 *
 * @constructor
 * @param {string} [id] - Textarea element #id
 * @param {string} [name] - Textarea element name
 * @param {function} [formatter] - Textarea value display formatter
 * @param {string} formatter.value - currently entered textarea
 * @param {object} [validate] - Validation config
 * @param {RegExp|string} validate.pattern - RegExp string to test against
 * @param {string} validate.patternReadable - Readable pattern string
 * @param {fuction} [validate.t] - Transform/translate error into readable message.<br>
 * If not specified, error message will be `${value} ${code}`<br>
 * For example see [i18next]{@link http://i18next.com/translate/} translator for generating error message.<br>
 * @param {'missing'|'no-match'|'not-int'|'not-num'|'out-of-bound'} validate.t.code - Error code
 * @param {object} validate.t.params - Parameters relevant to the error code
 * @param {string} validate.t.params.field - offending field name/id
 * @param {string} validate.t.params.value - offending field value
 * @param {RegExp|string} [validate.t.params.pattern] - pattern the value was supposed to follow
 * @param {string} [className] - Classname for the textarea
 * @param {string|number} [defaultValue] - Default value
 * @param {string|number} [value] - Current value
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {boolean} [required=false] - Is this field mandatory? If true will trigger validation.
 * @param {boolean} [disabled=false] - Is this field disabled?
 * @param {boolean} [readOnly=false] - Is this field readonly?
 * @param {string} [maxLength] - Maximum textarea length
 * @param {string} [placeholder] - Placeholder for textarea
 * @param {function} [onChange] - Callback function when value is changed. <br> Required when value prop is supplied
 * @param {string|number} onChange.value - updated value
 * @param {object} onChange.eventInfo - event related info
 * @param {string|number} onChange.eventInfo.before - previous value
 *
 * @example
// controlled
 */


var Textarea = /*#__PURE__*/function (_React$Component) {
  _inherits(Textarea, _React$Component);

  var _super = _createSuper(Textarea);

  function Textarea(props, context) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "blurHandler", function (evt) {
      var _this$state = _this.state,
          newValue = _this$state.value,
          error = _this$state.error;
      var _this$props = _this.props,
          oldValue = _this$props.value,
          onChange = _this$props.onChange;

      if (!error && onChange) {
        onChange(newValue);
      } else {
        _this.setState({
          value: oldValue,
          error: _this.validateInput(oldValue)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeHandler", function (evt) {
      var newVal = evt.target.value;

      if (_this.isComposing) {
        _this.setState({
          value: newVal
        });

        return;
      }

      var error = _this.validateInput(newVal);

      _this.nextTime = false;

      if (error) {
        evt.stopPropagation();
        evt.preventDefault();
        Popover.open(evt, error);

        _this.setState({
          error: error,
          value: newVal
        });
      } else {
        Popover.close();

        _this.setState({
          value: newVal,
          error: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "compositionHandler", function (evt) {
      if (evt.type === 'compositionend') {
        _this.isComposing = false;

        _this.changeHandler(evt);
      } else {
        _this.isComposing = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function (value) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          id = _this$props2.id,
          required = _this$props2.required,
          validate = _this$props2.validate;
      var error = validateField(value, _objectSpread({
        name: name || id,
        required: required
      }, validate)); // {code:params}

      if (error) {
        var message = error.message;
        return /*#__PURE__*/React.createElement("span", null, message);
      } else {
        return null;
      }
    });

    var _value = props.value;
    _this.state = {
      value: _value,
      error: _this.validateInput(_value)
    };
    _this.isComposing = false;
    return _this;
  }

  _createClass(Textarea, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Popover.close();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          id = _this$props3.id,
          name = _this$props3.name,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          placeholder = _this$props3.placeholder,
          maxLength = _this$props3.maxLength;
      var _this$state2 = this.state,
          value = _this$state2.value,
          error = _this$state2.error;
      var changeHandler = this.changeHandler;
      return /*#__PURE__*/React.createElement("textarea", {
        id: id,
        name: name,
        ref: function ref(_ref) {
          _this2.textarea = _ref;
        },
        readOnly: readOnly,
        disabled: disabled,
        maxLength: maxLength,
        onChange: changeHandler,
        onBlur: this.blurHandler,
        onCompositionStart: this.compositionHandler,
        onCompositionUpdate: this.compositionHandler,
        onCompositionEnd: this.compositionHandler,
        placeholder: placeholder,
        className: cx(className, {
          invalid: error
        }),
        value: value
      });
    }
  }]);

  return Textarea;
}(React.Component);

_defineProperty(Textarea, "defaultProps", {
  validate: {},
  required: false,
  disabled: false,
  readOnly: false
});

_defineProperty(Textarea, "propTypes", {
  id: PropTypes.string,
  name: PropTypes.string,
  formatter: PropTypes.func,
  validate: PropTypes.shape({
    pattern: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string]),
    patternReadable: PropTypes.string,
    t: PropTypes.func
  }),
  className: PropTypes.string,
  value: SIMPLE_VALUE_PROP,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  maxLength: PropTypes.number,
  placeholder: SIMPLE_VALUE_PROP,
  onChange: PropTypes.func
});

export default wireValue(Textarea);